export default {
  title: 'Vos préférences de communication ont été mises à jour.',
};
